module.exports = __webpack_public_path__ + "a96375743ad12637d1209f7cad5f39d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/fonts/ArialMT-Medium.svg
// module id = 362
// module chunks = 1